import React from "react";
import Step from "components/MainApp/atoms/Wizard/Step";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import ContactForm from "../../../components/ContactForm";

import styles from "./Step2.module.scss";
import i18n from "i18n";
export class AddProviderStepTwo extends React.Component {
  render() {
    const {
      provider,
      handleChange,
      goBack,
      handleContinue,
      enableContinue,
      error,
    } = this.props;
    const stepContent = (
      <form onSubmit={handleContinue}>
        <div className={styles["add-provider-wizard-step-two-content"]}>
          <ContactForm
            provider={provider}
            handleChange={handleChange}
            error={error}
          />
          <div className={styles["add-provider-wizard-step-two-action-wrapper"]}>
            <button
              type="submit"
              className={`${styles["add-provider-wizard-step-two-action-button"]}${!enableContinue ? ` ${styles["disabled"]}` : ""}`}
              onClick={enableContinue ? handleContinue : undefined}
            >
              {i18n.t("continue").toUpperCase()}
            </button>
          </div>
        </div>
      </form>
    );

    return (
      <div className={styles["add-provider-wizard-step-two-container"]}>
        <Step title={i18n.t("contact")} goBackFunc={goBack} content={stepContent}></Step>
      </div>
    );
  }
}

export default AddProviderStepTwo;
